import React, { createContext, useState, useContext, useEffect } from 'react';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);
  const [tourRunning, setTourRunning] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [tourCompleted, setTourCompleted] = useState(false);
  const [tourHistory, setTourHistory] = useState([]);

  // Check local storage for tour completion status
  useEffect(() => {
    const hasCompletedTour = localStorage.getItem('suprDriveTourCompleted') === 'true';
    setTourCompleted(hasCompletedTour);
  }, []);

  // Track step changes to maintain history
  useEffect(() => {
    if (tourRunning && !tourHistory.includes(stepIndex)) {
      setTourHistory(prev => [...prev, stepIndex]);
    }
  }, [stepIndex, tourRunning, tourHistory]);

  // Start the tour
  const startTour = (steps) => {
    setTourSteps(steps);
    setStepIndex(0);
    setTourHistory([0]);
    setIsTourOpen(true);
    setTourRunning(true);
  };

  // End the tour
  const endTour = () => {
    setIsTourOpen(false);
    setTourRunning(false);
    setTourHistory([]);
  };

  // Mark tour as completed
  const completeTour = () => {
    localStorage.setItem('suprDriveTourCompleted', 'true');
    setTourCompleted(true);
    endTour();
  };

  // Reset tour completion status
  const resetTour = () => {
    localStorage.removeItem('suprDriveTourCompleted');
    setTourCompleted(false);
  };

  // Handle going back
  const goBack = () => {
    if (stepIndex > 0) {
      const prevIndex = stepIndex - 1;
      setStepIndex(prevIndex);
      return true;
    }
    return false;
  };

  return (
    <TourContext.Provider
      value={{
        isTourOpen,
        tourSteps,
        stepIndex,
        tourRunning,
        tourCompleted,
        tourHistory,
        setStepIndex,
        setIsTourOpen,
        startTour,
        endTour,
        completeTour,
        resetTour,
        goBack
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext); 